import Vue from "vue";
// import md5 from "js-md5";
import config from "@/config";
import errorjs from "@/error";

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      logout: false
    },
    sessionToken: "",
    username: "",
    password: ""
  },
  mutations: {
    update(state, payload) {
      state.sessionToken = payload.sessionToken;
      state.username = payload.user.username;
      state.password = payload.user.password;
    },
    delete(state) {
      state.sessionToken = "";
      state.username = "";
      state.password = "";
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    }
  },
  actions: {
    login(context, user) {
      const url = config.loginUrl();
      const body = {
        user_id: user.username,
        password: user.password
      };
      const feedback = {
        success: false,
        status: errorjs.login.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("username" in user)) {
          feedback.status = errorjs.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorjs.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.username.length <= 0) {
          feedback.status = errorjs.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorjs.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorjs.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var sessionToken = null;
                  try {
                    sessionToken = successResponse.body.value[0].token;
                    if (sessionToken) {
                      context.commit("update", { sessionToken, user });
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorjs.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorjs.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorjs.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    }
  }
};
